<template>
  <div class="no-data">
    <slot></slot>
  </div>
</template>

<script>
export default {};
</script>

<style scoped lang="scss">
.no-data {
	position: absolute;
	z-index: 12;
	background: rgba(255, 255, 255, 0.8);
	width: 100%;
	height: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
}
</style>
